import storePersist from '../storePersist';
import * as actionTypes from './types';

const INITIAL_KEY_STATE: any = {
    result: null,
    current: null,
    isLoading: false,
    isSuccess: false,
};

const INITIAL_STATE: any = {
    current: {
        result: null,
    },
    list: {
        result: {
            items: [],
            pagination: {
                current: 1,
                pageSize: 5,
                total: 1,
                showSizeChanger: false,
            },
        },
        isLoading: false,
        isSuccess: false,
    },
    create: INITIAL_KEY_STATE,
    update: INITIAL_KEY_STATE,
    delete: INITIAL_KEY_STATE,
    read: INITIAL_KEY_STATE,
    search: { ...INITIAL_KEY_STATE, result: [] },
};

const batchLogsReducer = (state = INITIAL_STATE, action: any) => {
    const { payload, keyState } = action;
    switch (action.type) {
        case actionTypes.BATCH_LOGS_RESET_STATE:
            return INITIAL_STATE;
        case actionTypes.BATCH_LOGS_CURRENT_ITEM:
            return {
                ...state,
                current: {
                    result: payload,
                },
            };
        case actionTypes.BATCH_LOGS_REQUEST_LOADING:
            return {
                ...state,
                [keyState]: {
                    ...state[keyState],
                    isLoading: true,
                },
            };
        case actionTypes.BATCH_LOGS_REQUEST_FAILED:
            return {
                ...state,
                [keyState]: {
                    ...state[keyState],
                    isLoading: false,
                    isSuccess: false,
                },
            };
        case actionTypes.BATCH_LOGS_REQUEST_SUCCESS:

            return {
                ...state,
                [keyState]: {
                    result: payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };
        case actionTypes.BATCH_LOGS_CURRENT_ACTION:
            return {
                ...state,
                [keyState]: {
                    ...INITIAL_KEY_STATE,
                    current: payload,
                },
            };
        case actionTypes.BATCH_LOGS_RESET_ACTION:
            return {
                ...state,
                [keyState]: {
                    ...INITIAL_STATE[keyState],
                },
            };
        default:
            return state;
    }
};

export default batchLogsReducer;